const SearchModal = require('app/search/Modal');

class Navbar {
    defaultOptions() {
        return {
            '$navbar': null,//the <nav/> as jQuery object
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onSearch = this.onSearch.bind(this);

        this.$navbar = this.settings.$navbar;

        if(!this.$navbar || this.$navbar.length <= 0){
            return;
        }

        this.$formSearch = $('.restofute-global-search');
        this.$inputSearch = $('input[name="search"]',this.$formSearch);

        this.initialize();
    }

    initialize() {
        this.$formSearch.on('submit',this.onSearch);
        this.$inputSearch.on('change',this.onSearch);

        window.bindAutocomplete(this.$inputSearch,this.onSearch,500);
    }

    setSearch(search){
        this.$inputSearch.val(search);
    }

    onSearch(event){
        if(event){
            event.stopPropagation();
            event.preventDefault();
        }
        if(this.$inputSearch.val() && this.$inputSearch.val().length > 2){
            let modal = new SearchModal({
                'search': this.$inputSearch.val(),
                'onClose':function(){
                    modal.destroy();
                }
            });
        }
    }
}

module.exports = Navbar;

